export const formatDurationYandex = (minutes: number): string => {
  // Конвертируем в дни (8 часов = 1 рабочий день), часы и минуты
  const totalHours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  const days = Math.floor(totalHours / 8);
  const hours = totalHours % 8;

  // Формируем ISO 8601 duration string
  let result = 'P';

  if (days > 0) {
    result += `${days}D`;
  }

  if (hours > 0 || mins > 0) {
    result += 'T';

    if (hours > 0) {
      result += `${hours}H`;
    }

    if (mins > 0) {
      result += `${mins}M`;
    }
  }

  // Если только дни без времени, добавляем T0M чтобы не было просто P[n]D
  if (days > 0 && hours === 0 && mins === 0) {
    result = `P${days}DT0M`;
  }

  // Если совсем ничего нет, возвращаем минимальное значение
  if (result === 'P') {
    result = 'PT0M';
  }

  return result;
};
